import React from 'react';
import { toast, ToastContainer, ToastContent, ToastOptions as _ToastOptions } from 'react-toastify';

export type ToastOptions = _ToastOptions;
export interface IToastMessageOptions {
  type: 'success' | 'warning' | 'error' | 'warn';
  message: ToastContent;
  options?: ToastOptions | undefined;
}

const defaultToastOptions: ToastOptions = {
  position: 'bottom-right',
  draggable: true,
  draggablePercent: 40,
  autoClose: 5000,
  closeOnClick: true,
};

export const ToastMessage = (args: IToastMessageOptions) =>
  toast[args.type](args.message, args.options);

export const ToastService = (options?: ToastOptions | undefined) => {
  const _options = { ...defaultToastOptions, ...options };
  return <ToastContainer {..._options} />;
};
